var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',_vm._b({class:{ 'btn--icon': _vm.icon !== '', 'btn--transparent': _vm.transparent },on:{"click":function($event){return _vm.onClick($event)}}},'b-button',_vm.$attrs,false),[_vm._t("default"),(_vm.icon)?_c('icon',{staticClass:"btn__icon",attrs:{"icon":_vm.icon,"size":"18"}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }